import React from 'react';
import './App.css';
import { DevAuthProvider } from './components/DevAuthProvider';
import { SinglePageLayout } from './components/layout/SinglePageLayout';

function App() {
  return (
    <DevAuthProvider>
      <SinglePageLayout />
    </DevAuthProvider>
  );
}

export default App;
